import $ from 'jquery';

const allPartners = $('.accordions-block');

const setWidth = () => {
    const bodyWidth = $('body').outerWidth();

    if (window.matchMedia('(max-width: 575.98px)').matches) {
        allPartners.css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    } else {
        allPartners.css({
            width: '',
            marginLeft: '',
        });
    }
};

$(window).bind('resize', setWidth).trigger('resize');
